import { render, staticRenderFns } from "./ApplyJoinProject.vue?vue&type=template&id=4c70646e&"
import script from "./ApplyJoinProject.vue?vue&type=script&lang=js&"
export * from "./ApplyJoinProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports